import { decamelizeKeys } from 'humps';

import { pilot } from '~/services/serviceInstances';

type GetClientsParams = {
  clientId?: string;
  configs?: any;
};

export const updateClient = async ({
  clientId,
  configs,
}: GetClientsParams): Promise<boolean> => {
  const data = decamelizeKeys(configs);

  const response = await pilot.put(`client/${clientId}/`, data);

  return Boolean(response);
};
